var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.3455 21H9.65455C9.29305 21 9 20.707 9 20.3455V9.65455C9 9.29305 9.29305 9 9.65455 9H20.3455C20.707 9 21 9.29305 21 9.65455V20.3455C21 20.707 20.707 21 20.3455 21Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15 8.45455V3.65455C15 3.29305 14.707 3 14.3455 3H3.65455C3.29305 3 3 3.29305 3 3.65455V14.3455C3 14.707 3.29305 15 3.65455 15H8.45455","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Copy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
